import {
  Theme
} from '@cloudscape-design/components/theming';
import type { ThemeConfig as EmbedPdfThemeConfig } from '@embedpdf/react-pdf-viewer';

export const primaryButtonGreen = '#56dac5';
export const primaryGreenDarker = '#00a28f';
const secondaryButtonGrey = '#e2e6ea';
const darkGrey = '#1e1e1e';

export const embedPdfTheme: EmbedPdfThemeConfig = {
  preference: 'light',
  light: {
    accent: {
      primary: primaryButtonGreen,
      primaryActive: primaryGreenDarker,
      primaryForeground: 'white',
      primaryHover: primaryGreenDarker,
      primaryLight: 'rgba(86, 218, 197, 0.16)'
    },
    background: {
      app: '#f8fafc',
      elevated: 'white',
      input: 'white',
      overlay: 'rgba(15, 23, 42, 0.32)',
      surface: 'white',
      surfaceAlt: secondaryButtonGrey
    },
    border: {
      default: '#d1d5db',
      strong: primaryButtonGreen,
      subtle: secondaryButtonGrey
    },
    foreground: {
      disabled: '#94a3b8',
      muted: '#64748b',
      onAccent: 'white',
      primary: '#0f172a',
      secondary: '#475569'
    },
    interactive: {
      active: 'rgba(86, 218, 197, 0.16)',
      focus: primaryButtonGreen,
      focusRing: 'rgba(86, 218, 197, 0.28)',
      hover: 'rgba(15, 23, 42, 0.05)',
      selected: 'rgba(86, 218, 197, 0.12)'
    },
    scrollbar: {
      thumb: primaryButtonGreen,
      thumbHover: primaryGreenDarker,
      track: 'transparent'
    },
    state: {
      error: '#dc2626',
      errorLight: '#fef2f2',
      info: '#0284c7',
      infoLight: '#e0f2fe',
      success: primaryGreenDarker,
      successLight: 'rgba(86, 218, 197, 0.12)',
      warning: '#d97706',
      warningLight: '#fffbeb'
    },
    tooltip: {
      background: darkGrey,
      foreground: 'white'
    }
  }
};

export const themeObject: Theme = {
  tokens: {
    colorBackgroundLayoutMain: {
      // Specify value for light and dark mode
      light:
        'radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#62d29e]/40 via-[#62d29e]/20 to-white'
      // light: 'blue'
    },
    // font sizing and line heights
    // fontSizeBodyM: '0.9em',
    // fontSizeBodyS: '0.9em',
    // fontSizeDisplayL: fontSize,
    // fontSizeHeadingXl: headingConst,
    // fontSizeHeadingL: headingConst,
    // fontSizeHeadingM: headingConst,
    // fontSizeHeadingS: headingConst,
    // fontSizeHeadingXs: headingConst,
    // fontWeightHeadingXl: fontSize,
    // fontWeightHeadingL: fontSize,
    // fontWeightHeadingM: fontSize,
    // fontWeightHeadingS: fontSize,
    // fontWeightHeadingXs: fontSize,
    // lineHeightBodyM: '1em',
    // lineHeightBodyS: '1em',
    // lineHeightBodyS: fontSize,
    // lineHeightDisplayL: fontSize,
    // lineHeightHeadingXl: fontSize,
    // lineHeightHeadingL: fontSize,
    // lineHeightHeadingM: fontSize,
    // lineHeightHeadingS: fontSize,
    // lineHeightHeadingXs: fontSize,

    // borderRadiusContainer: '10px',
    // borderRadiusButton: '1px',
    // // colorTextButtonNormalActive: 'green',
    // // colorBackgroundButtonNormalDefault: 'green',
    // // primary buttons
    colorTextButtonPrimaryDefault: 'white',
    colorBackgroundButtonPrimaryDefault: primaryButtonGreen,
    colorBackgroundButtonPrimaryHover: primaryGreenDarker,

    colorBackgroundButtonPrimaryActive: primaryButtonGreen,
    colorTextButtonNormalActive: 'white', // when clicking on button
    colorBackgroundButtonNormalActive: primaryButtonGreen,
    // // normal buttons
    colorTextButtonNormalDefault: primaryButtonGreen, // normal button
    // colorBackgroundButtonNormalDefault: secondaryButtonGrey, // non selected button
    colorBorderButtonNormalDefault: primaryButtonGreen,
    colorTextButtonNormalHover: 'white',
    colorBorderButtonNormalHover: primaryButtonGreen,
    colorBackgroundButtonNormalHover: primaryButtonGreen,
    colorBorderItemSelected: primaryButtonGreen,

    // colorBackgroundContainerContent: '#f4f5f7',
    // colorBackgroundContainerHeader: '#f4f5f7',
    // // fontSizeDisplayL: '30px',
    // // fontSizeHeadingXl: '20px',
    // // lineHeightHeadingXl: '24px',
    // // fontSizeBodyM: '13px',
    // colorBackgroundCellShaded: '#c4cdd5',
    // colorBorderItemSelected: '#c4cdd5',
    // colorBackgroundItemSelected: '#c4cdd5', //table row border
    // colorBackgroundControlChecked: darkGrey, //select radio buttons and table selectiojns
    // // colorForegroundControlDefault: 'salmon', // the dots etc check mark for above
    // // colorBackgroundStatusSuccess: 'red',
    // // colorBorderDividerSecondary: 'lightBlue',
    // colorBorderDividerDefault: '#d1d5db', // outlines of containers and table etc
    // // colorTextBodyDefault: 'brown',
    // // colorTextHeadingDefault: 'brown'
    // // colorTextBr
    // colorTextBreadcrumbCurrent: 'black',
    // colorTextBreadcrumbIcon: 'black'
    // colorBackgroundContainerContent: backgroundTheme
    colorBackgroundControlChecked: {
      light: primaryButtonGreen,
      dark: primaryButtonGreen
    }
  }
};
